import React, { useState, useEffect } from "react";
import "../App.css";
// import useForm from "../UseForm";

// const FORM_ENDPOINT = "http://127.0.0.1:8000/push_data";
//const FORM_ENDPOINT = 'https://last-resort-api.azurewebsites.net/push_data'; // TODO - update to the correct endpoint

// const Form = () => {
//   const additionalData = {
//     request_date: new Date().toISOString().substring(0, 10),
//   };

//   const table = "raw_requests";

//   const { handleSubmit, status, message } = useForm({
//     additionalData,
//     table,
//   });

//   if (status === "success") {
//     return (
//       <>
//         <div></div>
//         <div>{message}</div>
//       </>
//     );
//   }

//   if (status === "error") {
//     return (
//       <>
//         <div>Something bad happened!</div>
//         <div>{message}</div>
//       </>
//     );
//   }

//   return (
//     <form
//       action={FORM_ENDPOINT}
//       onSubmit={handleSubmit}
//       mode="no-cors"
//       method="POST"
//     >
//       <div className="requestHeader">Request-a-Drink</div>
//       <div className="requestBox">
//         <input type="text" placeholder="Beer" name="request_item" />
//         <input
//           type="text"
//           placeholder="Brewery / Supplier"
//           name="request_supplier"
//         />
//       </div>
//       <div className="requestText">
//         Want to get the credit? ~~~~ Want to get a heads up if it comes on? ~~~~
//         Leave us your name and email (optional)
//       </div>
//       <div className="requestBox">
//         <input
//           type="text"
//           placeholder="Your name (optional)"
//           name="requester"
//         />
//         <input
//           type="text"
//           placeholder="Your email (optional)"
//           name="requester_email"
//         />
//       </div>
//       <div className="requestBox">
//         {status !== "loading" && <button type="submit">Submit</button>}
//       </div>
//     </form>
//   );
// };

class BeerRow extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.lineNum}</td>
        <td>{this.props.beer.name}</td>
        <td>{this.props.beer.brewery}</td>
        <td>{this.props.beer.beer_type}</td>
        <td>{this.props.beer.abv}%</td>
        <td>£{Number(this.props.beer.price).toFixed(2)}</td>
      </tr>
    );
  }
}

class BeerTable extends React.Component {
  // Split beers into casks and kegs
  categorizeBeers() {
    const casks = [];
    const kegs = [];

    this.props.beers.forEach((beer) => {
      if (beer.cask === "True") {
        casks.push(beer);
      } else if (beer.cask === "False") {
        kegs.push(beer);
      }
    });

    return { casks, kegs };
  }

  // Render a section (Cask or Keg)
  renderSection(title, beers) {
    return (
      <>
        <tr>
          <td colSpan="6" className="tableSubHead">
            {title}
          </td>
        </tr>
        {beers.map((beer, index) => (
          <BeerRow
            key={`${title.toLowerCase()}-${beer.name}-${index}`}
            beer={beer}
            lineNum={index + 1}
          />
        ))}
      </>
    );
  }

  render() {
    const { casks, kegs } = this.categorizeBeers();

    return (
      <table className="DataTable">
        <thead>
          <tr>
            <th>Line</th>
            <th>Name</th>
            <th>Brewery</th>
            <th>Type</th>
            <th>ABV</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {this.renderSection("Cask", casks)}
          {this.renderSection("Keg", kegs)}
        </tbody>
      </table>
    );
  }
}

// const Logo = () => {
//   const initialXPos = parseInt(0);
//   const [XPos, setXPos] = useState(initialXPos);
//   const initialYPos = parseInt(0);
//   const [YPos, setYPos] = useState(initialYPos);
//   const [transition, setTransition] = useState("right 1s linear");

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setXPos(prevXPos => {
//         const newXPos = (prevXPos + 10);
//         if (newPosition > 140) {
//           setTransition("right 0s linear")
//           // If the circle reaches the end, reset its position to the initial position
//           return -10;
//         } else {
//           setTransition("right 1s linear")
//           return newPosition;
//         }
//       });
//     }, 200);
//     return () => clearInterval(interval);
//   }, []);

//   return <div className="circle" style={{ right: `${position}%`, backgroundColor: color, top: `${props.yPos}%`, transition: transition}} />;
// };

const Drinks = () => {
  const [beers, setBeers] = useState([]);

  useEffect(() => {
    fetch("http://127.0.0.1:8000/get_data", {
      //mode: "no-cors",
      method: "POST",
      body: '{"query": "list_current_beers"}',
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setBeers(data);
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div>
      <div className="DrinksTable" style={{ zIndex: "1" }}>
        <BeerTable beers={beers} style={{ zIndex: "1" }} />
      </div>
      {/* <div style={{ zIndex: "1" }}>
        <Form style={{ position: "absolute", zIndex: "1" }} />
      </div> */}
    </div>
  );
};

export default Drinks;
